$(function() {
	if($(selectors.productGrid).length > 0){
		variantsHandlers();
	}

	$(window).on('product-recommendations:init', function () {
		variantsHandlers();
	})
});

var selectors = selectors || {
	productGrid: '.product-grid-container, .product-grid',
	swatchesWrapper: '.swatches',
	swatchesLabels: '.swatches label',
	cardWrapper: '.product-card-wrapper',
	swatch: '.swatch',
	productLinks: '.card__media > a, .card__information > a, .card__information > h3 > a',
	mainImage: '.card__media .media > img',
	variantImage: '.card__variant-image',
	priceWrapper: '.price',
	price: '.price .price__regular',
	salePrice: '.price .price__sale',
	addToCartButton: 'product-form button[name="add"]',
	variantTitle: '.card__variant-title',
	addToCartForm: 'product-form [data-type="add-to-cart-form"]'
};

var variantsHandlers = function(){
	$(selectors.productGrid).on('mouseover', selectors.swatch, function(){
		const variantImageSrc = $(this).data('src');
		const $variantImage = $(this).parents(selectors.cardWrapper).find(selectors.variantImage);
	
		$variantImage.attr('src', variantImageSrc).removeClass('opacity-0').addClass('opacity-100');
	});
	
	$(selectors.productGrid).on('mouseleave', selectors.swatch, function(){
		const $variantImage = $(this).parents(selectors.cardWrapper).find(selectors.variantImage);
	
		$variantImage.addClass('opacity-0').removeClass('opacity-100');
	});
	
	$(selectors.productGrid).on('click', selectors.swatch, function(){
		const $cardWrapper = $(this).parents(selectors.cardWrapper);
		const $mainImage = $cardWrapper.find(selectors.mainImage).first();
		const $hoverImage = $cardWrapper.find(selectors.mainImage).eq(1);
		const $variantID = $cardWrapper.find(selectors.addToCartForm).find('input[name="id"]');
		const $addToCartButton = $cardWrapper.find(selectors.addToCartButton);
		const $soldOutMessage = $addToCartButton.find('.sold-out-message');
	
		// mark as sold out
		if( $(this).data('sold-out') ){
			$addToCartButton.attr('aria-disabled', true);
			$addToCartButton.find('span').addClass('hidden');
			$soldOutMessage.removeClass('hidden');
		}else{
			$addToCartButton.attr('aria-disabled', false);
			$addToCartButton.find('span').removeClass('hidden');
			$soldOutMessage.addClass('hidden');
		}

		// update product price
		if( $(this).data('compare-at-price') ){
			$addToCartButton.find(selectors.priceWrapper).addClass('price--on-sale');
			$addToCartButton.find(selectors.salePrice).find('.price-item--sale').text( $(this).data('price') );
			$addToCartButton.find(selectors.salePrice).find('.price-item--regular').text( $(this).data('compare-at-price') );
		}else{
			$addToCartButton.find(selectors.priceWrapper).removeClass('price--on-sale');
			$addToCartButton.find(selectors.price).find('.price-item--regular').text( $(this).data('price') );
		}

		$cardWrapper.find(selectors.productLinks).attr('href', $(this).data('url'));
	
		// reset checked
		$cardWrapper.find(selectors.swatchesWrapper).find('input[type="radio"]').attr('checked', false);
		$(this).find('input[type="radio"]').attr('checked', true);
	
		if( $(this).data('src') !== '' ){
			$mainImage
				.attr('alt', $(this).data('alt'))
				.attr('src', $(this).data('src'))
				.attr('srcset', $(this).data('srcset'));
		}

		if( $(this).data('hover-src') !== '' ){
			$hoverImage
				.attr('alt', $(this).data('alt'))
				.attr('src', $(this).data('hover-src'))
				.attr('srcset', $(this).data('hover-srcset'));
		}

		$variantID.attr('value', $(this).data('id') );
		$cardWrapper.find(selectors.variantTitle).text( $(this).data('value') );
	});	
}